import { api, privateApi } from 'api'
import {
  IAdminAccessRow,
  IAdminEmployee,
  IAdminEmployeeAccess,
  IAdminEmployeeMe,
  IInviteAdminEmployeeRequest,
  IOpenAdminInvitationResponse,
  IUpdateAdminEmployeeRequest
} from 'models/adminEmployees'
import { ISendPhoneCodeResponse } from 'models/auth'
import {
  IAcceptInvitationRequest,
  IAcceptInvitationResponse,
  IConfirmOwnershipTransferRequest,
  IInvitationPhoneCodeResponse,
  IOwnershipCodesResponse
} from 'models/sellerEmployees'

export const adminEmployeesApi = {
  getMe() {
    return privateApi.get<IAdminEmployeeMe>('admin/employees/me')
  },
  getEmployees(includeFired?: boolean) {
    return privateApi.get<IAdminEmployee[]>('admin/employees', {
      params: { include_fired: includeFired || undefined }
    })
  },
  inviteEmployee(data: IInviteAdminEmployeeRequest) {
    return privateApi.post<IAdminEmployee>('admin/employees', data)
  },
  updateEmployee(id: string, data: IUpdateAdminEmployeeRequest) {
    return privateApi.patch<IAdminEmployee>(`admin/employees/${id}`, data)
  },
  requestPhoneCode(id: string, phone: number) {
    return privateApi.post<ISendPhoneCodeResponse>(
      `admin/employees/${id}/phone/code`,
      { phone: String(phone) }
    )
  },
  verifyPhoneCode(id: string, code: number) {
    return privateApi.post<IAdminEmployee>(
      `admin/employees/${id}/phone/verify`,
      { code }
    )
  },
  fireEmployee(id: string) {
    return privateApi.post<IAdminEmployee>(`admin/employees/${id}/fire`)
  },
  getAccess(id: string) {
    return privateApi.get<IAdminEmployeeAccess>(`admin/employees/${id}/access`)
  },
  // Строку без браузера узнаём по её единственному адресу
  block(id: string, { device_id, ips }: IAdminAccessRow) {
    return privateApi.post<IAdminEmployeeAccess>(
      `admin/employees/${id}/blacklist`,
      { device_id, ip: device_id ? null : ips[0] ?? null }
    )
  },
  unblock(id: string, { device_id, ips }: IAdminAccessRow) {
    return privateApi.delete<IAdminEmployeeAccess>(
      `admin/employees/${id}/blacklist`,
      {
        params: device_id ? { device_id } : { ip: ips[0] }
      }
    )
  },
  resendInvitation(id: string) {
    return privateApi.post<IAdminEmployee>(
      `admin/employees/${id}/invitation/resend`
    )
  },
  revokeInvitation(id: string) {
    return privateApi.delete<{ _id: string }>(
      `admin/employees/${id}/invitation`
    )
  },
  requestOwnershipTransfer(id: string) {
    return privateApi.post<IOwnershipCodesResponse>(
      `admin/employees/${id}/ownership/request`
    )
  },
  confirmOwnershipTransfer(id: string, data: IConfirmOwnershipTransferRequest) {
    return privateApi.post<IAdminEmployee>(
      `admin/employees/${id}/ownership/confirm`,
      data
    )
  },
  // Страница приглашения открыта без входа: доступ даёт токен из ссылки
  openInvitation(token: string) {
    return api.post<IOpenAdminInvitationResponse>(
      'admin/employees/invitation/open',
      { token }
    )
  },
  requestInvitationPhoneCode(token: string, phone: string) {
    return api.post<IInvitationPhoneCodeResponse>(
      'admin/employees/invitation/phone-code',
      { token, phone }
    )
  },
  acceptInvitation(data: IAcceptInvitationRequest) {
    return api.post<IAcceptInvitationResponse>(
      'admin/employees/invitation/accept',
      data
    )
  }
}
